import { rem } from 'polished';
import Action from './Action';
import Header from './Header';
import Item from './Item';
import React from 'react';
import Spacer from './Spacer';
import styled from 'styled-components';
const Wrapper = styled.div `
  height: ${({ theme }) => rem(theme.headerBar.height)};
  background-color: ${({ theme }) => theme.headerBar.backgroundColor};
  padding: ${rem(8)} ${rem(8)};
  display: flex;
  align-items: center;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  color: ${({ theme }) => theme.textColor};
  position: relative;
  z-index: 1;
`;
const HeaderBar = ({ children }) => {
    return React.createElement(Wrapper, null, children);
};
HeaderBar.Spacer = Spacer;
HeaderBar.Item = Item;
HeaderBar.Header = Header;
HeaderBar.Action = Action;
export default HeaderBar;
